// extracted by mini-css-extract-plugin
module.exports = {"presenterToolsHolder":"PresenterTools_presenterToolsHolder__CZEZ2"};